import { Archive, MoreHorizontal, PencilLine, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { ProjectCardView } from "@/features/projects";

type ProjectCardMenuProps = {
  onArchive: () => void;
  onDelete: () => void;
  onSettings: () => void;
  project: ProjectCardView;
};

export function ProjectCardMenu({
  onArchive,
  onDelete,
  onSettings,
  project,
}: ProjectCardMenuProps) {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label={`${t("projects.actions.settings")} ${project.title}`}
          size="icon"
          type="button"
          variant="ghost"
          className="h-9 w-9 border border-white/75 bg-white/82 shadow-sm hover:bg-white"
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onSettings}>
          <PencilLine className="h-4 w-4" />
          {t("projects.actions.settings")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          disabled={project.status === "archived"}
          onSelect={onArchive}
        >
          <Archive className="h-4 w-4" />
          {project.status === "archived"
            ? t("projects.actions.alreadyArchived")
            : t("projects.actions.archive")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="text-destructive focus:text-destructive"
          onSelect={onDelete}
        >
          <Trash2 className="h-4 w-4" />
          {t("projects.actions.delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
